module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-700.92425c6.woff2";